// @flow
export const FREEZER = new WeakSet();
